<template>
	<v-container>
		<v-row justify="center" align="center" v-if="selectedPlace && selectedService">
			<v-col cols="12" md="12">
				<data-empty
					fontColor="inherit"
					height="120"
					:title="
						selectedPlace.typeDocuments.length
							? 'Gestion de documentos'
							: 'No tiene documentos para mostrar'
					"
					msj="Para gestionar sus documentos, ve a establecimientos"
					action="places"
					backgroundColor="transparent"
				/>
			</v-col>
			<v-col v-if="selectedPlace.typeDocuments.length" cols="12">
				<span
					v-if="
						selectedPlace.documents.some(item => {
							if (item && item.date) return itsDue(item.date);
						})
					"
					dense
					text
					type="error"
				>
					{{ selectedPlace.name }} Tiene algun(os) documento(s) Caducado
				</span>
				<template v-else>
					<span
						v-if="
							Array.isArray(selectedPlace.typeDocuments) &&
								selectedPlace.typeDocuments.length &&
								selectedPlace.typeDocuments.some(
									typeDocument => typeDocument && typeDocument.done == false
								)
						"
						dense
						text
						type="warning"
					>
						{{ selectedPlace.name }} Tiene documento(s) pendiente
					</span>
					<span v-else dense text type="success">
						{{ selectedPlace.name }} Todo sus documentos Al día
					</span>
				</template>
				<v-slide-group
					v-model="slide"
					class="py-4 px-0"
					mandatory
					center-active
					show-arrows
				>
					<template v-for="(item, i) in selectedPlace.typeDocuments">
						<template v-if="item">
							<v-slide-item
								v-if="selectedPlace.documents[i]"
								:key="i"
								v-slot="{ toggle }"
							>
								<v-card
									class="ma-4"
									height="220"
									:width="$vuetify.breakpoint.lgAndUp ? '250' : '200'"
									@click="toggle"
								>
									<v-list-item
										:class="
											itsDue(selectedPlace.documents[i].date)
												? 'error'
												: 'success'
										"
										dark
									>
										<v-list-item-content>
											<v-list-item-title class="headline">
												{{ selectedPlace.documents[i].text }}
												<span>
													<v-icon
														dark
														small
														v-if="
															itsDue(selectedPlace.documents[i].date)
														"
													>
														mdi-clock-alert
													</v-icon>
													<v-icon dark small v-else>
														mdi-checkbox-marked-circle
													</v-icon>
												</span>
											</v-list-item-title>
										</v-list-item-content>
									</v-list-item>
									<v-card-text style="height: 120px">
										<div
											v-if="itsDue(selectedPlace.documents[i].date)"
											style="font-size: 8pt; height: 40px"
										>
											Caducado el
											{{ changeFormat(selectedPlace.documents[i].date) }}
										</div>
										<div v-else style="font-size: 8pt;height: 60px">
											Creado:
											{{ createAt(selectedPlace.documents[i].createdAt) }}
											{{
												selectedPlace.documents[i].date &&
													`- Vence: ${changeFormat(
														selectedPlace.documents[i].date
													)}`
											}}
											<br />
											(
											{{ getOffDays(selectedPlace.documents[i].date) }}

											<template
												v-if="
													getOffDays(selectedPlace.documents[i].date) !=
														'Sin vencimiento )'
												"
											>
												<span
													v-if="
														getOffDays(
															selectedPlace.documents[i].date
														) == '1'
													"
												>
													día)</span
												>
												<span v-else>dias)</span>
											</template>
										</div>
										<div
											class="headline"
											:class="
												itsDue(selectedPlace.documents[i].date)
													? 'error--text'
													: 'success--text'
											"
										>
											{{
												itsDue(selectedPlace.documents[i].date)
													? 'Caducado'
													: 'Al día'
											}}
										</div>
									</v-card-text>
									<v-card-actions v-if="selectedPlace.documents[i].url">
										<v-spacer></v-spacer>
										<v-btn
											color="success"
											small
											:href="selectedPlace.documents[i].url"
											target="_blank"
										>
											descargar
											<v-icon right>mdi-download</v-icon>
										</v-btn>
										<v-spacer></v-spacer>
									</v-card-actions>
								</v-card>
							</v-slide-item>
							<v-slide-item v-else :key="i" v-slot="{ toggle }">
								<v-card class="ma-4" height="220" width="250" @click="toggle">
									<v-list-item two-line class="warning" dark>
										<v-list-item-content>
											<v-list-item-title class="headline">
												{{ item.text }}
												<v-icon small color="white">
													mdi-file-question
												</v-icon>
											</v-list-item-title>
										</v-list-item-content>
									</v-list-item>
									<v-card-text>
										<div class="headline warning--text pt-8">
											Pendiente
										</div>
									</v-card-text>
								</v-card>
							</v-slide-item>
						</template>
					</template>
				</v-slide-group>
			</v-col>
			<v-col v-if="hasWorkOrders">
				<v-list two-line dense class="backgroundTransparent">
					<v-subheader>Ordenes de trabajo</v-subheader>
					<v-list-item-group
						color="primary"
						class="overflow-y-auto"
						style="max-height: 400px;"
					>
						<template v-for="workOrder in workOrders">
							<template v-if="workOrder">
								<v-list-item
									v-if="workOrder"
									:key="workOrder.type + ' ' + workOrder.id"
									tile
									link
									target="_blank"
									:href="generateWorkOrderLink(workOrder)"
								>
									<v-list-item-content class="text-left">
										<v-list-item-title class="text-capitalize">
											{{ workOrder.type }} N° {{ workOrder.id }}
										</v-list-item-title>
										<v-list-item-subtitle style="font-size: 8pt;">
											Creado por:
											{{
												workOrder.person.firstName +
													workOrder.person.lastName
											}}
										</v-list-item-subtitle>
										<v-list-item-subtitle style="font-size: 8pt;">
											Fecha:
											{{ workOrder.date }}
										</v-list-item-subtitle>
									</v-list-item-content>
								</v-list-item>
							</template>
						</template>
					</v-list-item-group>
				</v-list>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import { mapGetters } from 'vuex';
import moment from 'moment';

export default {
	components: {
		DataEmpty: () => import('@/components/ui/DataEmpty'),
	},
	data() {
		return {
			expandDocuments: false,
			slide: null,
		};
	},
	computed: {
		workOrders() {
			let orders = [];
			this.lodgings.forEach(lod => {
				if (lod.workOrder.length > 0) {
					lod.workOrder.forEach((wo, idx) => {
						orders.push({
							id: wo[0],
							type: wo[wo.length - 1],
							person: this.getPerson(lod.person),
							lodId: lod._id,
							index: idx,
							date: wo[1],
						});
					});
				}
			});
			return orders.sort((a, b) => b.id - a.id);
		},
		hasWorkOrders() {
			return this.lodgings.some(lod => {
				return lod.workOrder.length > 0;
			});
		},
		...mapGetters({
			selectedPlace: 'Lodging/selectedPlace',
			selectedService: 'Lodging/selectedService',
			listPerson: 'Person/persons',
			lodgings: 'Lodging/lodgings',
		}),
	},
	methods: {
		getPerson(id) {
			return this.listPerson.find(person => person._id == id);
		},
		generateWorkOrderLink(workOrder) {
			return `#/${workOrder.type}/${workOrder.lodId}/work-order/${workOrder.index}`;
		},
		itsDue(date) {
			return moment(date).isBefore(moment().format());
		},
		changeFormat(date) {
			return moment(date).format('DD-MM-YYYY');
		},
		getOffDays(date) {
			if (date == null) return 'Sin vencimiento )';
			let now = moment().format('YYYY-MM-DD');
			return moment(date).diff(now, 'days');
		},
		createAt(createAt) {
			if (createAt) return moment(createAt).format('l');
			else return 'Sin fechas';
		},
	},
};
</script>

<style lang="scss" scoped></style>
